import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {System} from './../../shared-components/System';
import {StudentService} from '../../shared-components/student/student.service';
import {YearService} from '../../shared-components/year/year.service';
import { LunchMealChoice} from './meal-service.model';
import {UserService} from '../../shared-components/user/user.service';
import {SharedService} from '../../shared-components/shared.service';

@Injectable({
    providedIn: 'root'
})
export class MealServiceService {
    selectionIndex: number;

    constructor(
        private http: HttpClient,
        private studentService: StudentService,
        private yearService: YearService,
        public userService: UserService,
        private sharedService: SharedService
    ) {
    }

    getMealService(studentId: number, yearId: number, siteYearId: number) {
        return this.sharedService.getMealService(studentId, yearId, siteYearId);
    }

    getMonthlyLunchMenu(studentId: number, siteYearId: number, startDate: Date, endDate: Date) {
        let queryString = '';
        queryString += '?studentId=' + studentId +
            '&siteYearId=' + siteYearId +
            '&startDate=' + startDate +
            '&endDate=' + endDate;
        return this.http.get<LunchMealChoice[]>(System.apiURL.Student + 'GetMothlyLunchMenu' + queryString);
    }

    getLunchPinForStudentAndStaff(studentId: number, siteId: number) {
        let queryString = '';
        queryString += '?yearId=' + this.yearService.student360Year.Id +
            '&siteId=' + siteId +
            '&studentId=' + studentId +
            '&userType=' + this.userService.userType;

        return this.http.get<string>(System.apiURL.Student + 'GetLunchPinForStudentAndStaff' + queryString);
    }

}
